export function init($name = '') {
    const chooser = $($name);

    if (!chooser.length) {
        return;
    }



    chooser.click(function(e) {
        
        const type = $(this).data('name');
        const parent = $(this).parents($name + '-parent');
        const nextParent = parent.next($name + '-parent');
        
        parent.find($name).removeClass('is-special-hovered');
        $(this).addClass('is-special-hovered');
        
        if(typeof $(this).data('name') === 'undefined') {
            return;
        }
        
        e.preventDefault();
        
        nextParent.find($name + '-form-input').val(type);

        nextParent.find($name + '-inputs').find('input:not([type="checkbox"])').val('');

        if (nextParent.find($name + '-inputs').find('input[type="checkbox"]').prop('checked')) {
            nextParent.find($name + '-inputs').find('input[type="checkbox"]').trigger('click');
        }

        if (type === 'relocation') {
            nextParent.find($name + '-inputs').removeClass('is-hidden').find('.js-trigger-input-field-non').find('input').attr('required', 'required');
            return;
        }

        nextParent.find($name + '-inputs').addClass('is-hidden').find('input').removeAttr('required');
    });
}